var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgVideocam = function SvgVideocam(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m19.478 16.055-3.426-2.112v-3.886l3.426-2.112a1 1 0 0 1 1.526.852v6.406a1 1 0 0 1-1.526.852Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.996 8.998a3 3 0 0 1 3-3h7.056a3 3 0 0 1 3 3v6.005a3 3 0 0 1-3 3H5.996a3 3 0 0 1-3-3V8.997Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVideocam);
export default ForwardRef;